define('plugin/classes/ClassesPlugin',['require','lib/plugin/PluginAbstract','Config','plugin/classes/step/ClassesPluginTimeStep','plugin/classes/step/ClassesPluginProviderStep'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var Config = require('Config');
    var ClassesPluginTimeStep = require('plugin/classes/step/ClassesPluginTimeStep');
    var ClassesPluginProviderStep = require('plugin/classes/step/ClassesPluginProviderStep');

    return PluginAbstract.extend({

        isEnabled: false,

        /**
         * Initialisation
         */
        initialize: function () {
            this.isEnabled = Config.getInstance().getTimelineType() === Config.TIMELINE_CLASSES_PLUGIN;
        },

        /**
         * Adds classes provider step before client details.
         * It will show only if client selected service instead of class
         *
         * @param Array steps
         * @return Array|null
         */
        modifySteps: function (steps) {
            if (this.isEnabled) {
                var index = _.indexOf(steps, 'datetime');

                steps.splice(index + 1, 0, 'provider');

                steps.splice(steps.indexOf('provider'), 1);
                steps.splice(steps.indexOf('service'), 1);
            }

            return steps;
        },

        /**
         * Returns plugin step object
         *
         * @see lib/controller/booking/BaseStep
         * @param String step - step name
         * @param Object params - step parameters
         * @return BaseStep|null
         */
        getStep: function (step, params) {
            if (this.isEnabled) {
                switch (step) {
                    case 'datetime':
                        return new ClassesPluginTimeStep(params);
                    case 'provider':
                        return new ClassesPluginProviderStep(params);
                }
            }
        }

    });

});
